import { render, staticRenderFns } from "./ShopLogin.vue?vue&type=template&id=1be28daa&scoped=true&"
import script from "./ShopLogin.vue?vue&type=script&lang=js&"
export * from "./ShopLogin.vue?vue&type=script&lang=js&"
import style0 from "./ShopLogin.vue?vue&type=style&index=0&id=1be28daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be28daa",
  null
  
)

export default component.exports